const MODAL_NAME = "setProjectMarketingTypeModal";

export { MODAL_NAME };
